module.exports = __webpack_public_path__ + "img/es-bottom.91663643.png";